import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import LeadershipBonuses from "./LeadershipBonuses";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("ahg-leadership-bonuses")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<LeadershipBonuses />
		</ThemeProvider>
	</StrictMode>
);
